import { createFileRoute } from "@tanstack/react-router";
import AuthPage from "@/pages/AuthPage";

export const Route = createFileRoute("/sign-in")({
  head: () => ({
    meta: [
        {
            "title": "Sign In | System Atlas - AI Study Assistant"
        },
        {
            "name": "description",
            "content": "Log in to System Atlas. Access your revision sheets, quizzes, and study plan. Continue studying smarter with AI."
        },
        {
            "property": "og:title",
            "content": "Sign In | System Atlas - AI Study Assistant"
        },
        {
            "property": "og:description",
            "content": "Log in to System Atlas. Access your revision sheets, quizzes, and study plan. Continue studying smarter with AI."
        },
        {
            "property": "og:type",
            "content": "website"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/sign-in"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Sign In | System Atlas - AI Study Assistant"
        },
        {
            "name": "twitter:description",
            "content": "Log in to System Atlas. Access your revision sheets, quizzes, and study plan. Continue studying smarter with AI."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/sign-in"
        }
    ],
  }),
  component: AuthPage,
});
